import { Navigate, useLocation } from "react-router-dom";
import { useDefaultAppRoute } from "../../hooks/useIsAdvertisersDemo";
import { readMcpAuthorizeReturnPath } from "../../utils/mcpOAuth";

export const PublicRoute = ({ children, restricted, isLogged }) => {
  const defaultRoute = useDefaultAppRoute();
  const location = useLocation();

  if (isLogged && restricted) {
    const returnPath = readMcpAuthorizeReturnPath({
      locationStateFrom: location.state?.from,
    });
    if (returnPath) {
      return <Navigate to={returnPath} replace />;
    }
    return <Navigate to={defaultRoute} />;
  }

  return children;
};
